<template>
  <div class="about">
    <b-container fluid>

    <b-modal
      title="Delete Audit"
      v-model="deleteAudit.show"
      v-on:ok="doDeleteAudit()"
      size="lg"
      centered
      lazy
      >
      This will permanently delete the audit '{{deleteAudit.audit? deleteAudit.audit.facilityName : ''}}'- do you wish to continue?
    </b-modal>
    <b-row>
      <b-col md="6" class="my-1">
        <b-button v-b-modal.create-audit-modal>
          Create New Audit
        </b-button>
        <b-modal
          ref="create-audit-modal"
          id="create-audit-modal"
          title="New Audit"
          size='lg'
          centered
          hide-footer
          lazy
          >
          <new-audit
            v-on:create-audit="createAudit"
          ></new-audit>
        </b-modal>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="auto" class="my-1">
        <div class="search-box shadow">
          <b-form-group class="form-row">
            <b-input-group>
              <b-form-input v-model="filter.facilityName" placeholder="Facility..." class="form-control" />
              <b-form-datepicker v-model="filter.startDate" size="sm" placeholder="Start Date" class="form-control"></b-form-datepicker>
              <b-form-datepicker v-model="filter.endDate" size="sm" placeholder="End Date" class="form-control"></b-form-datepicker>
              <b-form-select v-model="filter.state" :options="stateOptions" class="form-control"/>
  <!--            <b-form-input v-model="searchStatus" placeholder="State" /> -->
              <b-input-group-append>
                <b-button :disabled="!(searchFacility || searchStatus)" @click="clearAuditFilter">Clear Filter</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
      <b-col class="search-box row justify-content-end">
              <b-btn @click="archived=!archived">
                <div v-if="!archived">
                  <font-awesome-icon 
                      :icon="['fas', 'archive']"
                      >
                  </font-awesome-icon>
                  Archived Audits
                </div>
                <div v-if="archived">
                  <font-awesome-icon 
                      :icon="['fas', 'upload']"
                      >
                  </font-awesome-icon>
                  Active Audits
                </div>
              </b-btn>
      </b-col>
    </b-row>
    <b-row>
      <audit-stats :audits=filteredAudits>
      </audit-stats>
    </b-row>
    </b-container>
    
    <b-container fluid>
      <div class="table-area">
        <span v-if="archived"><h3>Archived Audits</h3></span>
        <span v-if="!archived"><h3>Active Audits</h3></span>
      
        <div class="table-responsive-sm">
          <b-table
            selectable
            bordered
            select-mode="single"
            selectedVariant="success"
            :items="audits"
            :fields="auditFields"
            @row-selected="auditRowSelected"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :per-page="perPage"
            :current-page="currentPage"
            striped
            :filter-function="filterFunc"
            :filter="filter"
            @filtered="onFilteredAudits"
          >
            <template v-slot:cell(facilityName)='data'>
              <b-link :to="{name:'currentAudit', params:{auditId:data.item.id}}">{{data.item.facilityName}}</b-link>
            </template>

            <template v-slot:cell(action)='data'>
              <b-dropdown size="sm">
                <b-dropdown-item-button 
                  v-if="!data.item.archived"
                  @click="archiveAudit(data.item)"
                  >
                  <font-awesome-icon 
                      :icon="['fas', 'archive']"
                      >
                  </font-awesome-icon>
                  Archive
                </b-dropdown-item-button>
                <b-dropdown-item-button 
                  v-if="data.item.archived"
                  @click="unArchiveAudit(data.item)"
                  >
                  <font-awesome-icon 
                      :icon="['fas', 'upload']"
                      >
                  </font-awesome-icon>
                  Unarchive
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  @click="startDeleteAudit(data.item)"
                  >
                  <font-awesome-icon 
                      :icon="['fas', 'trash-alt']"
                      >
                  </font-awesome-icon>
                  Delete
                </b-dropdown-item-button>
<!--
                <b-dropdown-item-button>
                  Rename
                </b-dropdown-item-button>
-->
              </b-dropdown>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="filteredAuditCount"
            :per-page="perPage"
            >
          </b-pagination>
        </div>
      </div>
    </b-container>
  </div>
</template>


<script>
import { Auth } from 'aws-amplify'
import NewAudit from '@/components/NewAudit.vue'
import AuditStats from '@/components/charts/AuditStats.vue'
import { mapState } from 'vuex'

export default {
    props:[
      "archived"
    ],
    data() {
      return {
        currentPage: 1,
        deleteAudit: {
          show:false,
          audit:null
        },
        filter: {
          facilityName: null,
          startDate: null,
          endDate: null,
          state: 'all',
        },
        perPage: 10,
        filteredAudits: [],
        searchFacility: null,
        searchStatus: "inprogress",
        stateOptions: [
          {value: 'inprogress', text: 'In Progress'},
          {value: 'in-review', text: 'In Review'},
          {value: 'review-complete', text: 'Review Complete'},
          {value: 'complete', text: 'Complete'},
          {value: 'all', text: 'All'}
          ],
        'auditFields': [
          {
              key: 'facilityName',
              'label': 'Facility Name',
              sortable: true
          },
          {
              key: 'date',
              'label': 'Date',
              sortable: true
          },
          {
              key: 'state',
              sortable: true,
              formatter: 'prettyStatus',
              label: 'Status'
          },
          {
              key: 'action',
              sortable: false,
              label: 'Action',
              tdClass: 'actionColumn'
          },
        ],
        sortBy:'facilityName',
        sortDesc: false
      }
    },
    computed: mapState({
      audits: state => state.audits.all,
      auditCount: state => state.audits.all.length,
      auditSelected: state => state.currentAudit.header,
      filteredAuditCount() {
        return this.filteredAudits.length;
      },
      filterFunc() {
        console.log("new filter func!")
        return (row, filter) => {
          let result = true;
          //console.log("runnin a filter func!", row.facilityName, filter)
          if( filter.facilityName) {
            result = result && row.facilityName.includes(filter.facilityName)
          } 
          if (filter.state != 'all') {
            let state = filter.state;
            let reviewState = null
            if(state == 'review-complete') {
              state = 'in-review'
              reviewState = 'complete'
            }
            result = result && row.state == state
            if (reviewState) {
              result = result && row.reviewState == reviewState
            }
          }
          if (row.date) {
            let auditDate = new Date(row.date)
            if (filter.startDate) {
//                console.log("startDate", auditDate.getTime(), filter.startDate.getTime())
              result = result && auditDate.getTime() >= new Date(filter.startDate).getTime()
            }
            if (filter.endDate) {
//                console.log("sendDate", auditDate.getTime(), filter.endDate.getTime())
              result = result && auditDate.getTime() <= new Date(filter.endDate).getTime()
            }
          }
          if (this.archived) {
            result = result && row.archived
          } else {
            result = result && !row.archived
          }
          return result
        }
      }
    }),
    components: {
      'new-audit': NewAudit,
      'audit-stats': AuditStats,
    },
    methods: {
      archiveAudit: async function(audit) {
        console.log("archiving audit", audit)
        this.$store.dispatch('audits/archiveAudit', {auditId:audit.id, archived:true})
      },
      unArchiveAudit: async function(audit) {
        console.log("unarchiving audit", audit)
        this.$store.dispatch('audits/archiveAudit', {auditId:audit.id, archived:false})
      },
      startDeleteAudit: async function(audit) {
        this.deleteAudit.audit = audit
        this.deleteAudit.show = true
      },
      doDeleteAudit: async function() {
        this.$store.dispatch('audits/deleteAudit', {auditId: this.deleteAudit.audit.id})
        this.deleteAudit.audit = null
        this.deleteAudit.show = false
      },

      auditRowSelected: async function(items) {
        if( items && items.length) {
          const id = items[0].id
          console.log("retrieving", id)
          let audit = this.$store.getters['audits/auditById'](id)
          this.$store.dispatch('currentAudit/setCurrent', audit)
        }
      },
      filterAudits(row, filter) {
        if( filter.facilityName) {
          return row.facilityName.includes(filter.facilityName)
        } else {
          return true
        }
      },
      clearAuditFilter: async function() {
        this.filter = {
          facilityName: null,
          startDate: null,
          endDate: null,
          archived: false,
          state: 'all',
        }
        this.initAudits()
      },
      initAudits: async function() {
        const user = await Auth.currentAuthenticatedUser()
        this.$store.dispatch('audits/loadAudits', user.username)
      },
      patchImages: async function(list) {
        console.log("patching ", list)
        if( list.questions ) {
          list.questions.forEach(q => {
            if(q.image) {
              if( !q.images)
                q.images = []
              q.images.push(q.image)
              console.log("patching ", q.image, q.images)
              q.image = null
            }
          })
        }
        if(list.sublists) {
          list.sublists.forEach(s => {
            this.patchImages(s)
          })
        }
      },
      async createAudit() {
          this.$refs["create-audit-modal"].hide()
      },
      prettyStatus(status, key, item) {
        if(status == 'inprogress') return "In Progress"
        else if(status == 'in-review') { 
          if(item.reviewState == 'complete') {
            return 'Review Complete'
          } else {
            return 'In Review'
          }
        }
        else if(status == 'complete') return 'Complete'
        else return status
      },
      onFilteredAudits(filteredAudits) {
        this.filteredAudits = filteredAudits;
      }
    },
    async beforeCreate() {
      // TODO: figure out how to share code with init audits above
        console.log("dispatching load audits")
        const user = await Auth.currentAuthenticatedUser()
        this.$store.dispatch('audits/loadAudits', user.username)
    }

}
</script>

<style>
  .actionColumn {
    width: 25px;
    max-width: 50px;
  }
</style>